/**
 * @author wuTao
 * @description 组织路径完成率部分字段
 * @Date 2021/12/14
 */
import React from "react";
import { connect } from "dva";
import { framework_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';
import { mapStateToProps, handleExport } from '../../utils';

const { WizContainer, WizReduxTemplate } = framework_tool;

class OrgPathCompletionInfo extends WizContainer {
  componentName = "OrgPathCompletionInfo";

  _render() {
    let columnsType = true;
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: handleExport.bind(this, { title: '组织路径完成率', column,columnsType })
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(mapStateToProps.bind(this, { nameSpace: 'pathReport', method: 'getPageListOrg' }))(OrgPathCompletionInfo);
